module.exports = __webpack_public_path__ + "static/img/gold.0c44c9f1.png";